import callBackend from '../shared/methods/callBackend/callBackend';

const deleteExcluded = async (ruleId) => callBackend({
  url: `${process.env.REACT_APP_API_URL}/trackingexcluded/${ruleId}`,
  method: 'DELETE',
});

export default deleteExcluded;
